import { imageGetters } from '../../../../helpers/imageGetters';
import { videoGetters } from '../../../../helpers/videoGetters';
import styles from './VideoPreview.module.css';

export function VideoPreview() {
  return (
    <div className={styles.root}>
      <video
        className={styles.video}
        src={videoGetters.installInstruction()}
        poster={imageGetters.videoPoster()}
        autoPlay
        loop
        muted
        playsInline
        disablePictureInPicture
      />
    </div>
  );
}
